import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "feature-cards" }
const _hoisted_3 = { class: "card-content" }
const _hoisted_4 = { class: "card-content" }
const _hoisted_5 = { class: "contact-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Document = _resolveComponent("Document")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_Management = _resolveComponent("Management")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("section", { class: "hero" }, [
      _createElementVNode("h1", { class: "main-title" }, "AI助力大学生简历优化，让简历更专业，求职管理更高效"),
      _createElementVNode("p", { class: "sub-title" }, "专为大学生打造的助手，提供简历优化和资源管理工具")
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_el_row, { gutter: 30 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                class: "feature-card",
                shadow: "hover",
                onClick: _ctx.goToResume
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_icon, { class: "card-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Document)
                      ]),
                      _: 1
                    }),
                    _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "card-title" }, "简历优化", -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "card-desc" }, " 使用STAR法则-情境、任务、行动、结果-优化项目经历描述，让简历更具说服力 ", -1)),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      class: "card-btn"
                    }, {
                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode("开始优化")
                      ])),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                class: "feature-card",
                shadow: "hover",
                onClick: _ctx.goToResources
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_icon, { class: "card-icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Management)
                      ]),
                      _: 1
                    }),
                    _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "card-title" }, "资源管理", -1)),
                    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "card-desc" }, " 自主整理资源-公司、职位、投递进度、经验贴-通过仪表盘让求职过程井然有序 ", -1)),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      class: "card-btn"
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("开始管理")
                      ])),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_5, [
      _cache[7] || (_cache[7] = _createStaticVNode("<h2 class=\"section-title\" data-v-68bbcd5a>关于</h2><div class=\"contact-desc\" data-v-68bbcd5a><p class=\"desc-paragraph\" data-v-68bbcd5a> 本网站由个人开发，秉持免费无广告的理念，致力于提升大学生求职体验。 </p><p class=\"desc-paragraph\" data-v-68bbcd5a> 本网站专注于简历优化和求职资源管理两大核心功能。在资源管理方面，仅作为个人自我资源的整理工具，供用户管理自主收集的资源，网站不提供任何资源内容。对于用户自行收集整理的内容，本网站不承担相关责任。 </p><p class=\"desc-paragraph highlight\" data-v-68bbcd5a> 希望各位都能在人生的岔路口找到东南西北~ </p></div>", 2)),
      _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: _ctx.goToAbout
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("了解更多")
        ])),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}